$(".js-bookmarking-click-create").click(function(){
  $(this).removeClass("btn-bookmark--bookmark");
  $(this).addClass("btn-bookmark--bookmarked");
  $(this).html("Bookmarked");
});

$(".js-bookmarking-click-destroy").click(function(){
  $(this).removeClass("btn-bookmark--bookmarked");
  $(this).addClass("btn-bookmark--bookmark");
  $(this).html("Bookmark");
});
